import {
  GenericPipelineParameterMappingFragment,
  GenericPipelineParameterMappingSource,
} from '@warebee/frontend/data-access-api-graphql';
import _ from 'lodash';
import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '../../common/utils';
import DropdownSelector from '../../components/actions/DropdownSelector';
import usePipelineTemplateParameterSourceDescriptors from '../templateDescriptors/usePipelineTemplateParameterSourceDescriptors';

export type PipelineTemplateParameterEditorWrapProps = PropsWithChildren & {
  value: GenericPipelineParameterMappingFragment;
  onChange: (value: GenericPipelineParameterMappingFragment) => void;
};

const PipelineTemplateParameterEditorWrap: React.FC<
  PipelineTemplateParameterEditorWrapProps
> = props => {
  const { t } = useTranslation('app');
  const { value, onChange } = props;
  const sourceOptionsMap = usePipelineTemplateParameterSourceDescriptors();
  const sourceOptionSelected =
    sourceOptionsMap[
      value.source ?? GenericPipelineParameterMappingSource.CONSTANT
    ];
  function applyPatch(patch: Partial<GenericPipelineParameterMappingFragment>) {
    props.onChange({ ...value, ...patch });
  }

  return (
    <div>
      <DropdownSelector
        label={t`Source`}
        className={cn(
          'min-w-0 flex-1 transform text-sm transition-all duration-200',
        )}
        value={props.value?.source || t('No Data Selected')}
        values={_.keys(sourceOptionsMap)}
        renderValue={(id: string) => sourceOptionsMap[id]?.title || id}
        onChange={(source: GenericPipelineParameterMappingSource) =>
          applyPatch({
            source,
          })
        }
        panelMode
        DropAlignRight
        widthFull
        valuePrimary
        light
      />
      {sourceOptionSelected.showValueEditor && props.children}
    </div>
  );
};

export default PipelineTemplateParameterEditorWrap;
